import React from 'react';

import { WizardPage } from './WizardPage';

type Props = Omit<React.ComponentProps<typeof WizardPage>, 'onBack'>;

const TerminalWizardPage: React.FC<Props> = (props) => {
  return <WizardPage {...props} />;
};

export { TerminalWizardPage };
